/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vue Monica Refine Design
  Author: Riyan Kurniawan
  -- MONICA --
==========================================================================================*/


const actions = {

    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////
    addNotifData({commit}, item) {
        commit('ADD_NOTIF_DATA', item)
    },
    updateCounter({commit}, item) {
        commit('UPDATE_COUNTER', item)
    },
    resetCounter({commit}, item) {
        commit('RESET_COUNTER', item)
    },
    markNotificationAsRead({commit}, notificationId) {
        commit('MARK_NOTIFICATION_AS_READ', notificationId)
    },
    updateSidebarWidth({commit}, width) {
        commit('UPDATE_SIDEBAR_WIDTH', width);
    },
    updateI18nLocale({commit}, locale) {
        commit('UPDATE_I18N_LOCALE', locale);
    },
    toggleContentOverlay({commit}) {
        commit('TOGGLE_CONTENT_OVERLAY');
    },
    updateTheme({commit}, val) {
        commit('UPDATE_THEME', val);
    },
    updateUserRole({commit}, val) {
        commit('UPDATE_USER_ROLE', val);
    },


    // ////////////////////////////////////////////
    // COMPONENT
    // ////////////////////////////////////////////

    // VxAutoSuggest
    updateStarredPage({commit}, payload) {
        commit('UPDATE_STARRED_PAGE', payload)
    },

    //  The Navbar
    arrangeStarredPagesLimited({commit}, list) {
        commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({commit}, list) {
        commit('ARRANGE_STARRED_PAGES_MORE', list)
    },
}

export default actions
